import React, { createRef, useState, useEffect } from 'react';

import HourDisplayer from 'common/components/HourDisplayer/HourDisplayer';
import DatesService from 'common/services/Dates';
import IconsMapper from 'common/components/IconsMapper/IconsMapper';

import './OpeningHours.css';

const OpeningHours = ({ merchant }) => {
  const [hoursDisplayed, setHoursDisplayed] = useState(false);
  const [todayClosingTime, setTodayClosingTime] = useState('');
  const hoursDetails = createRef();

  const storeIsOpen = DatesService.storeIsOpen(merchant.workingTime);

  const toggleHoursDisplay = () => {
    setHoursDisplayed(!hoursDisplayed);
  };

  useEffect(() => {
    const getTodayClosingTime = () => {
      if (!storeIsOpen) {
        return;
      }
      try {
        const actualDayToString = DatesService.getActualDayToStringKey();
        const todayArray =
          merchant.workingTime.workingDaysPerWeek[actualDayToString];
        const lastWorkingTime = todayArray[todayArray.length - 1]?.end;
        let result = '';
        if (lastWorkingTime) {
          result = lastWorkingTime.replace(':', 'h');
        } else {
          const todayAdditionalDay = DatesService.getTodayAdditionalDay(
            merchant.workingTime.additionalDays,
          );
          if (todayAdditionalDay) {
            const loastWorkingTimeAdditional =
              todayAdditionalDay.hours[todayAdditionalDay.hours.length - 1]
                ?.end;
            result = loastWorkingTimeAdditional.replace(':', 'h');
          }
        }
        setTodayClosingTime(result);
      } catch (err) {
        console.log('DATE PARSE ERROR', err);
      }
    };
    getTodayClosingTime();
  }, [
    merchant.workingTime.workingDaysPerWeek,
    merchant.workingTime.additionalDays,
    storeIsOpen,
  ]);

  useEffect(() => {
    if (hoursDetails.current) {
      hoursDetails.current.style.display = hoursDisplayed ? 'block' : 'none';
    }
  }, [hoursDisplayed, hoursDetails]);

  return (
    <section
      className="openingHoursWrapper sl-radius-m"
      onClick={() => toggleHoursDisplay()}
      aria-labelledby="opening-hours-title"
      itemProp="openingHoursSpecification"
      itemScope
      itemType="https://schema.org/OpeningHoursSpecification"
    >
      <h2 id="opening-hours-title" className="sl-title sl-text-l">
        {storeIsOpen ? "Ouvert aujourd'hui" : 'Actuellement Fermé'}
      </h2>
      {storeIsOpen && (
        <p aria-live="polite">
          <time>jusqu'à {todayClosingTime}</time>
        </p>
      )}
      <hr aria-hidden="true" />
      <div>
        <button
          type="button"
          className="flexGap showHours"
          aria-expanded={hoursDisplayed}
          aria-controls="opening-hours-details"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            width: '100%',
            color: 'var(--tertiary-color) !important',
          }}
        >
          <span>
            <small>Consulter tous les horaires</small>
          </span>
          <span
            aria-hidden="true"
            style={
              hoursDisplayed
                ? {
                    transition: '0.3s',
                  }
                : {
                    transform: 'rotate(90deg)',
                    transition: '0.3s',
                  }
            }
          >
            <IconsMapper icon={'faChevronDown'}></IconsMapper>
          </span>
        </button>
      </div>
      <div
        id="opening-hours-details"
        className="hourDisplayerWrapper"
        ref={hoursDetails}
        style={{ display: 'none' }}
        role="region"
        aria-label="Horaires détaillés"
      >
        <HourDisplayer></HourDisplayer>
      </div>
    </section>
  );
};

export default OpeningHours;
